import { render, staticRenderFns } from "./settingsData.vue?vue&type=template&id=f2bf2ad2&scoped=true&"
import script from "./settingsData.vue?vue&type=script&lang=js&"
export * from "./settingsData.vue?vue&type=script&lang=js&"
import style0 from "./settingsData.vue?vue&type=style&index=0&id=f2bf2ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf2ad2",
  null
  
)

export default component.exports